import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { PageListRef } from "../../../../components/PageList";
import { ITable, TableList } from "../../../../components/TableList";
import { useApi } from "../../../../hooks/api";
import { useGlobal } from "../../../../hooks/global";
import { IActions, IContractModelsProps } from "../../../../interfaces";
import { IoAddCircleOutline } from "react-icons/io5";
import { background, primary, secondary } from "../../../../theme";
import { FaEdit, FaRegEye } from "react-icons/fa";
import { ModalContractModel } from "../../../../components/Modals/ModalMessageModel copy";
import { FiltersRef, SearchWithFilters } from "../../../../components/SearchWithFilters";
import { HeaderList } from "../../../../components/HeaderList";
import { Box } from "@mantine/core";
import { MdDelete } from "react-icons/md";
import { ModalViewContractModel } from "../../../../components/Modals/ModalViewContractModel";

const initialTable: ITable = {
    data: [],
    columns: [
        {
            attr: "title",
            name: "Título",
            style: { textAlign: "left" },
            styleContent: { fontSize: 16, fontWeight: 600 },
        },
    ],
};

const ContractModels = ({ openNewContractModel, setOpenNewContractModel, contractModelSelected, setContractModelSelected }: { openNewContractModel: boolean, setOpenNewContractModel: (open: boolean) => void, contractModelSelected: IContractModelsProps | null, setContractModelSelected: (contractModel: IContractModelsProps | null    ) => void }) => {
    const { user, api } = useApi();
    const { theme, paginationLimit, notify } = useGlobal();

    const [table, setTable] = useState<ITable>(initialTable);
    const [isFetching, setIsFetching] = useState(false);
    const [atualPage, setAtualPage] = useState(1);

    const [loadingContractsModels, setLoadingContractsModels] = useState(false/* true */);
    const [searchString, setSearchString] = useState<string>("");
    const [numberOfPages, setNumberOfPages] = useState<number>(1);
    const [numOfData, setNumOfData] = useState(0);
    const [updatedAt, setUpdatedAt] = useState(new Date());
    const page_ref = React.useRef<PageListRef>(null);
    const [selecteds, setSelecteds] = useState<string[]>([]);
    const filter_ref = useRef<FiltersRef>(null);
    const [loadingDelete, setLoadingDelete] = useState(false);

    const [contractModelId, setContractModelId] = useState<string>("");
    const [openViewContractModel, setOpenViewContractModel] = useState(false);
    const searchContractsModels = useCallback(async (page, search = null) => {
        setIsFetching(true);
        setAtualPage(page);
        setLoadingContractsModels(true);

        try {
            let url = `/contract-models/?page=${page}&limit=${paginationLimit}&search=${search}`;

            const result = await api.get(url);
            const contract_models = result.data.data as IContractModelsProps[];

            setTable((atual) => {
                const new_table = { ...atual };

                new_table.data = [];
                contract_models.forEach((model) => {
                    new_table.data.push({
                        id: model.id,
                        title: model?.title,
                        status: model?.status,

                        this: model,
                    });
                });

                return { ...new_table };
            });

            setNumOfData(result.data.total);
            setNumberOfPages(Math.ceil(result.data.count / paginationLimit));
            setUpdatedAt(new Date());
        } catch (err) {
            notify("Erro na busca pelas Empresas!", "error");
        }

        setLoadingContractsModels(false);
    },
        [user, searchString]
    );

    const selectContractModel = useCallback(
        (model: IContractModelsProps) => {
            setContractModelSelected({ ...model });
            setOpenNewContractModel(true);
        },
        []
    );

    const handleAction = useCallback((action_id: string) => {
        setContractModelSelected(null);
        setOpenNewContractModel(true);
    }, []);

    const onSave = useCallback(() => {
        setOpenNewContractModel(false);
        searchContractsModels(1);
    }, [user, searchString]);

    const changeStatus = useCallback(
        async (id: string, old_status: boolean) => {
            const status_active = !old_status;

            setTable((atual) => {
                const new_table = { ...atual };
                const pos = new_table.data.findIndex((d) => d?.this.id === id);
                if (pos !== -1) new_table.data[pos].this.status = status_active;
                return { ...new_table };
            });

            try {
                await api.put(`/contract-models/${id}`, { status: status_active });
                notify("Status do modelo de contrato atualizado com sucesso", "success");
            } catch (err) {
                notify("Erro ao alterar status da empresa", "error");
                setTable((atual) => {
                    const new_table = { ...atual };
                    const pos = new_table.data.findIndex((d) => d?.this.id === id);
                    if (pos !== -1) new_table.data[pos].this.status = old_status;
                    return { ...new_table };
                });
            }
        },
        []
    );

    const actionsInitial: IActions[] = [
        {
            main_option: { text: "Novo modelo de contrato", id: "new_item" },
            className: "new_item",
            icon: <IoAddCircleOutline size={20} className="new_item" />,
            options: [],
            type: "solid",
            permissions: ["SETTINGS-LIST"],
        },
    ];

    const handleDelete = useCallback(async (id: string) => {
        const result = window.confirm("Deseja realmente deletar este modelo de contrato?");
        if (!result) return;

        setLoadingDelete(true);
        try {
            await api.delete(`/contract-models/${id}`);
            notify("Modelo de contrato deletado com sucesso!", "success");
            searchContractsModels(atualPage, { ...filter_ref.current?.getFilters(), search: searchString });
        } catch (err) {
            notify("Erro ao deletar modelo de contrato!", "error");
        }
        setLoadingDelete(false);
    }, []);

    const handleOpenModalView = (id: string) => {
        setContractModelId(id);
        setOpenViewContractModel(true);
    };

    const listAction = [
        {
            title: "Editar",
            onClick: (contractModel: IContractModelsProps) => selectContractModel(contractModel),
            icon: <FaEdit color={secondary[theme]} size={20} />,
            disabled: () => false,
        },
        {
            title: "Visualizar",
            onClick: (contractModel: IContractModelsProps) => handleOpenModalView(contractModel.id),
            icon: <FaRegEye color={secondary[theme]} size={20} />,
            disabled: () => false,
        },
        {
            title: "Deletar",
            onClick: (contractModel: IContractModelsProps) => handleDelete(contractModel.id),
            icon: <MdDelete color={secondary[theme]} size={20} />,
            disabled: () => false,
        },
    ];

    const props = useMemo(() => ({
        updatedAt: updatedAt,
        loading: loadingContractsModels,
        setLoading: setLoadingContractsModels,
        numberOfItems: numOfData,
        onClickOption: handleAction,
        textHeader: "Modelos de contrato",
        textItems: "modelos de contrato encontrados",
        text_loading: "Buscando Modelos de contrato",
        text_empty: "Nenhum modelo de contrato encontrado",
        theme: theme,
        actions: actionsInitial,
        initialFilters: [],
        onChangeFilters: () => { },
        table: table,
        pages: numberOfPages,
        page: atualPage,
        search: searchContractsModels,
        onChangeSearch: setSearchString,
        listActions: listAction,
        ref: page_ref,
        have_status: true,
        status_action: changeStatus,
        noHeader: true,
    }), [updatedAt, loadingContractsModels, setLoadingContractsModels, numOfData, handleAction, theme, actionsInitial, table, numberOfPages, atualPage, searchContractsModels, setSearchString, page_ref, changeStatus]);

    const handleChangeSelecteds = useCallback(
        (selecteds: string[]) => {
            setSelecteds(selecteds);
        },
        [props]
    );

    useEffect(() => {
        if (table.data.length === 0 && !isFetching) {
            console.log("searchContractsModels");
            searchContractsModels(1, { ...filter_ref.current?.getFilters(), search: searchString });
        }
    }, [searchContractsModels, filter_ref.current?.getFilters(), searchString, table.data, isFetching]);

    return (
        <>
            <Box bg={primary[theme]} px={16} py={5} style={{ borderRadius: 5 }}>
                <TableList {...props} moduleName="contractModels" onChangeSelecteds={handleChangeSelecteds} />
            </Box>

            {openNewContractModel && (
                <ModalContractModel
                    onCancel={() => setOpenNewContractModel(false)}
                    onSave={onSave}
                    openModal={openNewContractModel}
                    backgroundVisible={false}
                    defaultId={contractModelSelected?.id}
                />
            )}

            {openViewContractModel && (
                <ModalViewContractModel
                    openModal={openViewContractModel}
                    contractModelId={contractModelId}
                    onCancel={() => setOpenViewContractModel(false)}
                    backgroundVisible={true}
                />
            )}
        </>
    );
}

export default ContractModels